import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

/** Red circular letter mark — brand “J” or user initial. Shows `imageUrl` when set. */
export function RedCircleMark({
  letter,
  imageUrl,
  size = 'md',
  className,
}: {
  letter: string;
  imageUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const src = imageUrl?.trim() || '';
  const [imgFailed, setImgFailed] = useState(false);
  useEffect(() => {
    setImgFailed(false);
  }, [src]);

  const box =
    size === 'sm' ? 'h-7 w-7' : size === 'lg' ? 'h-10 w-10' : 'h-9 w-9';
  const type =
    size === 'sm'
      ? 'text-[13px] font-bold'
      : size === 'lg'
        ? 'text-sm font-bold'
        : 'text-sm font-bold';
  const ch = (letter.trim().charAt(0) || 'U').toUpperCase();

  if (src && !imgFailed) {
    return (
      <div
        className={cn(box, 'rounded-full overflow-hidden shrink-0 bg-white ring-1 ring-black/10', className)}
        aria-hidden
      >
        <img
          src={src}
          alt=""
          referrerPolicy="no-referrer"
          className="h-full w-full object-contain"
          onError={() => setImgFailed(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={cn(box, 'rounded-full flex items-center justify-center shrink-0 bg-[#E8002D]', className)}
      aria-hidden
    >
      <span className={cn(type, 'leading-none text-white')}>{ch}</span>
    </div>
  );
}

export function BrandMarkJ({
  size = 'md',
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  return <RedCircleMark letter="J" size={size} className={className} />;
}
